import { useState as H, useEffect as i, useCallback as P } from "react";
import { getHashParamFromWindow as u, getHashParamsFromWindow as c, setHashParamInWindow as d, stringToBase64String as I, stringFromBase64String as v, blobToBase64String as F, blobFromBase64String as S } from "../core/index.js";
import { deleteHashParamFromUrl as D, deleteHashParamFromWindow as N, getHashParamValue as x, getHashParamValueBase64DecodedFromUrl as C, getHashParamValueBase64DecodedFromWindow as L, getHashParamValueBooleanFromUrl as T, getHashParamValueBooleanFromWindow as _, getHashParamValueFloatFromUrl as A, getHashParamValueFloatFromWindow as j, getHashParamValueIntFromUrl as q, getHashParamValueIntFromWindow as z, getHashParamValueJsonFromUrl as G, getHashParamValueJsonFromWindow as K, getUrlHashParams as M, getUrlHashParamsFromHashString as O, setHashParamValueBase64EncodedInUrl as Q, setHashParamValueBase64EncodedInWindow as R, setHashParamValueBooleanInUrl as X, setHashParamValueBooleanInWindow as Y, setHashParamValueFloatInUrl as Z, setHashParamValueFloatInWindow as $, setHashParamValueInHashString as f, setHashParamValueInUrl as k, setHashParamValueIntInUrl as y, setHashParamValueIntInWindow as aa, setHashParamValueJsonInHashString as sa, setHashParamValueJsonInUrl as ra, setHashParamValueJsonInWindow as na } from "../core/index.js";
const l = (o, a) => {
  const [s, r] = H(u(o) ?? a);
  i(() => {
    const [n, t] = c();
    a && t[o] === void 0 && d(o, a);
  }, [a]), i(() => {
    const n = (t) => {
      const e = c()[1];
      r(e[o]);
    };
    return window.addEventListener("hashchange", n), () => window.removeEventListener("hashchange", n);
  }, []);
  const m = P((n, t) => {
    d(o, n, t);
  }, []);
  return [s, m];
}, U = (o, a) => {
  const [s, r] = l(o, a != null ? I(a) : void 0), [m, n] = H(a);
  i(() => {
    n(s ? v(s) : void 0);
  }, [o, s, n]);
  const t = P((e, h) => {
    if (e == null)
      r(void 0, h);
    else {
      const g = I(e);
      r(g, h);
    }
  }, [r]);
  return [m, t];
}, W = (o, a) => {
  const [s, r] = l(o), [m, n] = H(!!a);
  i(() => {
    n(a ? s !== "false" : s === "true");
  }, [a, o, s, n]);
  const t = P((e, h) => {
    e = !!e, r(e === !!a ? void 0 : a ? "false" : "true", h);
  }, [a, r]);
  return [m, t];
}, J = (o, a) => {
  const [s, r] = l(o, a != null ? a.toString() : void 0), [m, n] = H(s ? parseFloat(s) : void 0);
  i(() => {
    n(s ? parseFloat(s) : void 0);
  }, [o, s, n]);
  const t = P((e, h) => {
    r(e ? e.toString() : void 0, h);
  }, [r]);
  return [m, t];
}, V = (o, a) => {
  const [s, r] = l(o, a != null ? a.toString() : void 0), [m, n] = H(s ? parseInt(s) : void 0);
  i(() => {
    n(s ? parseInt(s) : void 0);
  }, [o, s, n]);
  const t = P((e, h) => {
    r(e ? e.toString() : void 0, h);
  }, [r]);
  return [m, t];
}, b = (o, a) => {
  const [s, r] = l(o, a != null ? F(a) : void 0), [m, n] = H(S(s));
  i(() => {
    n(S(s));
  }, [o, s, n]);
  const t = P((e, h) => {
    if (e == null)
      r(void 0, h);
    else {
      const g = F(e);
      r(g, h);
    }
  }, [r]);
  return [m, t];
};
export {
  S as blobFromBase64String,
  F as blobToBase64String,
  D as deleteHashParamFromUrl,
  N as deleteHashParamFromWindow,
  u as getHashParamFromWindow,
  x as getHashParamValue,
  C as getHashParamValueBase64DecodedFromUrl,
  L as getHashParamValueBase64DecodedFromWindow,
  T as getHashParamValueBooleanFromUrl,
  _ as getHashParamValueBooleanFromWindow,
  A as getHashParamValueFloatFromUrl,
  j as getHashParamValueFloatFromWindow,
  q as getHashParamValueIntFromUrl,
  z as getHashParamValueIntFromWindow,
  G as getHashParamValueJsonFromUrl,
  K as getHashParamValueJsonFromWindow,
  c as getHashParamsFromWindow,
  M as getUrlHashParams,
  O as getUrlHashParamsFromHashString,
  d as setHashParamInWindow,
  Q as setHashParamValueBase64EncodedInUrl,
  R as setHashParamValueBase64EncodedInWindow,
  X as setHashParamValueBooleanInUrl,
  Y as setHashParamValueBooleanInWindow,
  Z as setHashParamValueFloatInUrl,
  $ as setHashParamValueFloatInWindow,
  f as setHashParamValueInHashString,
  k as setHashParamValueInUrl,
  y as setHashParamValueIntInUrl,
  aa as setHashParamValueIntInWindow,
  sa as setHashParamValueJsonInHashString,
  ra as setHashParamValueJsonInUrl,
  na as setHashParamValueJsonInWindow,
  v as stringFromBase64String,
  I as stringToBase64String,
  l as useHashParam,
  U as useHashParamBase64,
  W as useHashParamBoolean,
  J as useHashParamFloat,
  V as useHashParamInt,
  b as useHashParamJson
};
//# sourceMappingURL=index.js.map
